export const SourceSystems = {
  ACUMATICA: {
    slug: 'acumatica',
    name: 'Acumatica',
  },
  CMIC: {
    slug: 'cmic',
    name: 'CMiC',
  },
  QUICKBOOKS_DESKTOP: {
    slug: 'quick-books-desktop',
    name: 'QuickBooks Desktop',
  },
  QUICKBOOKS_ONLINE: {
    slug: 'quick-books-online',
    name: 'QuickBooks Online',
  },
  SAGE_100_CONTRACTOR: {
    slug: 'sage-100-contractor',
    name: 'Sage 100 Contractor',
  },
  SAGE_300_CRE: {
    slug: 'sage-300-cre',
    name: 'Sage 300 CRE',
  },
  SAGE_INTACCT: {
    slug: 'sage-intacct',
    name: 'Sage Intacct',
  },
  SPECTRUM: {
    slug: 'spectrum',
    name: 'Spectrum',
  },
  VIEWPOINT_VISTA_HOSTED: {
    slug: 'vista-hosted',
    name: 'Vista Hosted',
  },
};

// this is the const that is used as a reference generally within the code/frontend for Agave related functionality
export const AgaveSourceSystem = {
  ACUMATICA: SourceSystems.ACUMATICA.slug,
  CMIC: SourceSystems.CMIC.slug,
  QUICKBOOKS_DESKTOP: SourceSystems.QUICKBOOKS_DESKTOP.slug,
  QUICKBOOKS_ONLINE: SourceSystems.QUICKBOOKS_ONLINE.slug,
  SAGE_100_CONTRACTOR: SourceSystems.SAGE_100_CONTRACTOR.slug,
  SAGE_300_CRE: SourceSystems.SAGE_300_CRE.slug,
  SAGE_INTACCT: SourceSystems.SAGE_INTACCT.slug,
  SPECTRUM: SourceSystems.SPECTRUM.slug,
  VIEWPOINT_VISTA_HOSTED: SourceSystems.VIEWPOINT_VISTA_HOSTED.slug,
};

// this is the const that is used as a reference for frontend formatted options (e.g. inital connection in @ConnectToYourAccountingSystem.tsx)
export const SourceSystemOptions = {
  [SourceSystems.ACUMATICA.slug]: SourceSystems.ACUMATICA.name,
  [SourceSystems.QUICKBOOKS_DESKTOP.slug]: SourceSystems.QUICKBOOKS_DESKTOP.name,
  [SourceSystems.QUICKBOOKS_ONLINE.slug]: SourceSystems.QUICKBOOKS_ONLINE.name,
  [SourceSystems.SAGE_300_CRE.slug]: SourceSystems.SAGE_300_CRE.name,
  [SourceSystems.SAGE_INTACCT.slug]: SourceSystems.SAGE_INTACCT.name,
  [SourceSystems.SPECTRUM.slug]: SourceSystems.SPECTRUM.name,
  [SourceSystems.VIEWPOINT_VISTA_HOSTED.slug]: SourceSystems.VIEWPOINT_VISTA_HOSTED.name,
};

// ERPs available in Speedchain's direct ERP integration (ERPv1).
// Separate from SourceSystemOptions to avoid side-effects on Agave connection page.
// Additional ERPs (CMiC, Sage 100) will be added as those integrations are built.
export const ERPSpeedchainOptions = {
  [SourceSystems.ACUMATICA.slug]: SourceSystems.ACUMATICA.name,
  [SourceSystems.QUICKBOOKS_DESKTOP.slug]: SourceSystems.QUICKBOOKS_DESKTOP.name,
  [SourceSystems.QUICKBOOKS_ONLINE.slug]: SourceSystems.QUICKBOOKS_ONLINE.name,
  [SourceSystems.SAGE_300_CRE.slug]: SourceSystems.SAGE_300_CRE.name,
  [SourceSystems.SAGE_INTACCT.slug]: SourceSystems.SAGE_INTACCT.name,
  [SourceSystems.SPECTRUM.slug]: SourceSystems.SPECTRUM.name,
  [SourceSystems.VIEWPOINT_VISTA_HOSTED.slug]: SourceSystems.VIEWPOINT_VISTA_HOSTED.name,
};

export const SourceSystemsWithGLCodes = [
  AgaveSourceSystem.QUICKBOOKS_DESKTOP,
  AgaveSourceSystem.QUICKBOOKS_ONLINE,
  AgaveSourceSystem.SAGE_100_CONTRACTOR,
  AgaveSourceSystem.SAGE_300_CRE,
  AgaveSourceSystem.SAGE_INTACCT,
];

export const SourceSystemsPostingDisabled: string[] = [];
